import { Box } from '@material-ui/core';
import StroeInfo from './components/StoreInfo';
import EmpSearch from './components/EmpSearch';
import IndexStyled from './IndexStyled';

export default () => {
  return (
    <IndexStyled
      ml={15}
      mr={15}
      height={'100%'}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        data-log={JSON.stringify({
          oid: 'page_offline_store_customer_search_details',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        width={'100%'}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Box>
          <StroeInfo></StroeInfo>
        </Box>
        <Box mt={0} width="100%">
          <EmpSearch></EmpSearch>
        </Box>
      </Box>
    </IndexStyled>
  );
};
